import { useEffect, useState } from 'react';
import { API } from 'src/api';

import { ChatWithPdf } from '../components/ChatWithPdf';
import { PdfUpload } from '../components/pdfUpload';

export interface message {
  type: 'question' | 'answer';
  content: string;
}

export const PdfChat = ({ id, fileId }: { id: string; fileId?: string }) => {
  const [pdfUrl, setPDFUrl] = useState('');
  const [fileName, SetFileName] = useState('');
  const [file, setFile] = useState('');
  const [messages, setMessages] = useState<message[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOnDrop = async (file) => {
    setIsLoading(true);
    const data = new FormData();
    data.append('file', file[0]);
    fileId && data.append('id', fileId);
    const response = await API.post('/files/pdf-chat/upload', data, {
      headers: { ['Content-Type']: 'multipart/form-data' },
    });
    if (response) {
      setIsLoading(false);
      setPDFUrl(response.data.url);
      SetFileName(response.data.filename);
      setFile(response.data.file);
    }
  };
  const formatResponse = (chatData: any) => {
    chatData.map((obj) => {
      setMessages((prev) => [...prev, { type: 'answer', content: obj.answer }]);
      setMessages((prev) => [...prev, { type: 'question', content: obj.question }]);
    });
  };

  useEffect(() => {
    const getFile = async () => {
      try {
        const response = await API.get(`/files/pdf-chat/file?id=${fileId}`);
        if (response.data.success) {
          setPDFUrl(response.data.data.url);
          SetFileName(response.data.filename);
          setFile(response.data.data.file);
          formatResponse(response.data.data.answers);
        } else {
          setPDFUrl('');
          SetFileName('');
          setFile('');
        }
      } catch (error) {
        console.error(error);
      }
    };

    getFile();
  }, [fileId]);

  return (
    <div className="flex bg-gray-100" style={{ height: `calc(100vh - 50px)` }}>
      <PdfUpload
        translations={{
          attachments_drop_label: 'Upload pdf',
          attachments_label: 'Upload pdf',
        }}
        onDrop={handleOnDrop}
        maxFileSize={3e7}
        multiple={false}
        acceptTypes={['.pdf']}
        pdfUrl={pdfUrl}
        isLoading={isLoading}
      />
      <ChatWithPdf
        pdfUrl={pdfUrl}
        file={file}
        fileName={fileName}
        fileId={fileId}
        messages={messages}
        setMessages={setMessages}
      />
    </div>
  );
};
